import React from 'react'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'
import {
  ChangelogContainer,
  ChangelogHeader,
  ChangelogHeaderText,
  Logs,
} from './Changelog.styles'
import { ChangelogPage } from './ChangelogPage'
import { CHANGELOG_PAGE_SIZE } from './ChangelogPage.helpers'

export const Changelog = ({
  subjectmodelids,
  hideHeader = true,
  subjectIds,
  subjectType,
  isDashboardWidget: isWide,
}: {
  subjectmodelids?: string[]
  hideHeader?: boolean
  subjectIds?: string[]
  subjectType?: MODEL_TYPE
  isDashboardWidget?: boolean
}): JSX.Element => {
  return (
    <ChangelogContainer $isWide={isWide}>
      {!hideHeader && (
        <ChangelogHeader>
          <ChangelogHeaderText>Activities</ChangelogHeaderText>
        </ChangelogHeader>
      )}
      <Logs>
        <ChangelogPage
          itemsPerPage={CHANGELOG_PAGE_SIZE}
          subjectModelIds={subjectmodelids}
          subjectIds={subjectIds}
          subjectType={subjectType}
          isWide={isWide}
        />
      </Logs>
    </ChangelogContainer>
  )
}
